import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PermissionDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class PermissionApiClient extends BaseCRUDApiClient<PermissionDto> {
  baseUrl = this.config.apiEndpoint + '/permission';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
